import { render, staticRenderFns } from "./oma.vue?vue&type=template&id=572c2f86&scoped=true"
import script from "./oma.vue?vue&type=script&lang=js"
export * from "./oma.vue?vue&type=script&lang=js"
import style0 from "./oma.vue?vue&type=style&index=0&id=572c2f86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c2f86",
  null
  
)

export default component.exports